import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import { Engagement, Productivity, Talent, Wellbeing } from '@assets/icons'

import Container from '../../Home.style'
import * as Style from './Benefits.style'

export default function Benefits() {
  return (
    <Style.Wrapper>
      <Container>
        <Row>
          <Col xxs={12} xl-start={2} xl={6}>
            <Style.Title>
              <FormattedMessage
                id="smb_acquisition_home.benefits.title"
                values={{
                  span: (...chunks) => <span>{chunks}</span>,
                }}
              />
            </Style.Title>
          </Col>
        </Row>

        <Style.ListWrapper>
          <Row>
            <Col xxs={12} xl={3}>
              <Style.Item>
                <Style.ItemIcon
                  src={Wellbeing}
                  alt="Two women meditating in a black and white filter"
                />

                <Style.ItemDescription>
                  <Style.ItemTitle>
                    <FormattedMessage id="smb_acquisition_home.benefits.company.benefit_1.title" />
                  </Style.ItemTitle>
                  <Style.ItemSubtitle>
                    <FormattedMessage id="smb_acquisition_home.benefits.company.benefit_1.subtitle" />
                  </Style.ItemSubtitle>
                </Style.ItemDescription>
              </Style.Item>
            </Col>

            <Col xxs={12} xl={3}>
              <Style.Item>
                <Style.ItemIcon
                  src={Productivity}
                  alt="A woman and two men discussing a problem in a board with black and white filter"
                />

                <Style.ItemDescription>
                  <Style.ItemTitle>
                    <FormattedMessage id="smb_acquisition_home.benefits.company.benefit_2.title" />
                  </Style.ItemTitle>
                  <Style.ItemSubtitle>
                    <FormattedMessage id="smb_acquisition_home.benefits.company.benefit_2.subtitle" />
                  </Style.ItemSubtitle>
                </Style.ItemDescription>
              </Style.Item>
            </Col>

            <Col xxs={12} xl={3}>
              <Style.Item>
                <Style.ItemIcon
                  src={Engagement}
                  alt="A group of people very happy about something with black and white filter"
                />

                <Style.ItemDescription>
                  <Style.ItemTitle>
                    <FormattedMessage id="smb_acquisition_home.benefits.company.benefit_3.title" />
                  </Style.ItemTitle>
                  <Style.ItemSubtitle>
                    <FormattedMessage id="smb_acquisition_home.benefits.company.benefit_3.subtitle" />
                  </Style.ItemSubtitle>
                </Style.ItemDescription>
              </Style.Item>
            </Col>

            <Col xxs={12} xl={3}>
              <Style.Item>
                <Style.ItemIcon
                  src={Talent}
                  alt="A smiling woman working in a laptop with black and white filter"
                />

                <Style.ItemDescription>
                  <Style.ItemTitle>
                    <FormattedMessage id="smb_acquisition_home.benefits.company.benefit_4.title" />
                  </Style.ItemTitle>
                  <Style.ItemSubtitle>
                    <FormattedMessage id="smb_acquisition_home.benefits.company.benefit_4.subtitle" />
                  </Style.ItemSubtitle>
                </Style.ItemDescription>
              </Style.Item>
            </Col>
          </Row>
        </Style.ListWrapper>
      </Container>
    </Style.Wrapper>
  )
}
